import { render } from "./KpiList.vue?vue&type=template&id=8c4e1288&scoped=true"
import script from "./KpiList.vue?vue&type=script&lang=js"
export * from "./KpiList.vue?vue&type=script&lang=js"

import "./KpiList.vue?vue&type=style&index=0&id=8c4e1288&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c4e1288"]])

export default __exports__